import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'arrayFilter',
    pure: false
})
export class ArrayFilterPipe implements PipeTransform {
    transform(items: any[], property: string, value: string): any {
        if (!items) {
            return items;
        }

        return items.filter(item => item[property] === value);
    }
}